import "./index.css";
const Loader = () => {
  return (
    <div className="loader-container">
      <div className="flex space-x-2">
        <span className="loader [animation-delay:-0.3s]"></span>
        <span className="loader [animation-delay:-0.15s]"></span>
        <span className="loader"></span>
      </div>
    </div>
  );
};

export default Loader;
